import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from '../../api/constants'
import { axiosPrivate } from '../../api/axios'

const initialState = {
  facilities: [],
  fetchLoading: false,
  updateLoading: false,
  fetchError: null,
  updateError: null,
}

// Async thunk to fetch teams data from API
export const fetchFacilities = createAsyncThunk(
  API_URL.FACILITIES,
  async ({ axiosInstance = axiosPrivate, params = {
    pageNo: 0,
    pageSize: 1000,
  } }, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams(params).toString()
      const url = `${API_URL.FACILITIES}?${queryParams}`
      // Fetching facilities data from the API
      const response = await axiosInstance.get(url)
      return response.data
    } catch (error) {
      console.error('Error fetching facilities:', error)
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data || 'Failed to fetch facilities',
      })
    }
  }
)

export const updateFacilityStatus = createAsyncThunk(
  'facility/updateStatus',
  async ({ axiosInstance = axiosPrivate, facilityId, active }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${API_URL.FACILITIES}/${facilityId}`, { active })
      return response.data
    } catch (error) {
      console.error('Error updating facility status:', error)
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data || 'Failed to update facility status',
      })
    }
  }
)

const facilitySlice = createSlice({
  name: 'facility',
  initialState,
  reducers: {
    clearFacilities(state) {
      state.facilities = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFacilities.pending, (state) => {
        state.fetchLoading = true;
        state.fetchError = null;
      })
      .addCase(fetchFacilities.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.facilities = action.payload.facilities || [];
      })
      .addCase(fetchFacilities.rejected, (state, action) => {
        state.fetchLoading = false;
        state.fetchError = action.payload;
      })
      .addCase(updateFacilityStatus.pending, (state) => {
        state.updateLoading = true;
        state.updateError = null;
      })
      .addCase(updateFacilityStatus.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateError = null;
        const updatedFacility = action.payload;
        if (!Array.isArray(state.facilities)) {
          state.facilities = [];
        }
        const index = state.facilities.findIndex(
          (facility) => facility.id === updatedFacility.id
        );
        if (index !== -1) {
          state.facilities[index] = {
            ...state.facilities[index],
            active: updatedFacility.active,
          };
        }
      })
      .addCase(updateFacilityStatus.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = action.payload;
      });

  },
})

export const facilityActions = facilitySlice.actions

export const facilityReducer = facilitySlice.reducer

export const getFacilities = (state) => state.facility.facilities
export const getFacilitiesLoading = (state) => state.facility.loading
export const getFacilitiesError = (state) => state.facility.error
export const getFetchLoading = (state) => state.facility.fetchLoading;
export const getUpdateLoading = (state) => state.facility.updateLoading;
export const getFetchError = (state) => state.facility.fetchError;
export const getUpdateError = (state) => state.facility.updateError;
